// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Q2-z","colorTextValue":"R2-z","swatches":"S2-z","collapseLink":"T2-z","isCollapsed":"U2-z","dropdown":"V2-z","disabled":"W2-z"};